<template>
  <div id="app">
    <div class="navWrapper">
      <div class="navContainer">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
          <a class="navbar-brand" href="https://www.blockchyp.com"><img src="/static/images/stacked-logo.svg" width="120" height="73"/></a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item" v-for="item in menu" v-bind:key="item.id">
                <a class="nav-link" :href="item.url" :target="item.target">{{ item.caption }}</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/login">Login</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
    <div class="navHeader">
      <h3>{{caption}}</h3>
    </div>
    <div class="slim-mainpanel">
      <div class="container">
        <router-view @captionChange="handleCaptionChange" class="view"></router-view>
        <div class="card card-blog-split mg-t-20">
          <div class="row no-gutters flex-row-reverse">
            <div class="col-md-5 col-lg-6 col-xl-5">
              <figure>
                <img src="/images/terminal-clipped.png" class="img-fit-cover" alt="">
              </figure>
            </div><!-- col-md-5 -->
            <div class="col-md-7 col-lg-6 col-xl-7">
              <h5 class="blog-title"><a href="https://www.blockchyp.com/contact">Need Help?</a></h5>
              <div class="blog-text">
                <p>
                  We've tried to simplify this stuff as much as possible, but we know
                  it can still be time consuming and confusing.  If you'd like someone
                  from BlockChyp to help you with your statements, feel free to
                  <a href="https://www.blockchyp.com/contact">contact us</a>.
                </p>
                <p><a class="btn btn-success" href="https://www.blockchyp.com/contact">CONTACT BLOCKCHYP</a></p>
              </div>

            </div><!-- col-md-7 -->
          </div><!-- row -->
        </div><!-- card -->
      </div>
    </div>
    <div>


    </div>

    <div class="slim-footer">
      <div class="container">
        <p>Copyright &copy; 2018-{{currentYear}} <a href="https://www.blockchyp.com">BlockChyp, Inc.</a></p>
      </div><!-- container -->
   </div><!-- slim-footer -->
 </div> <!-- app -->
</template>

<script>
import axios from 'axios'

export default {
  name: 'app',
  data: () => ({
    caption: 'PROCESSING FEE COMPARISON TOOL',
    menu: []
  }),
  computed: {
    currentYear: function () {
      return new Date().getFullYear()
    }
  },
  methods: {
    handleCaptionChange: function (caption) {
      this.caption = caption
    }
  },
  mounted () {
    let self = this
    axios.get('/api/content/menu')
      .then(function (response) {
        self.menu = response.data
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>
